/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} White_Last_Wasp_CryInputs */

const fr_white_last_wasp_cry = /** @type {(inputs: White_Last_Wasp_CryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sécurité`)
};

/**

* @param {White_Last_Wasp_CryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const white_last_wasp_cry = /** @type {((inputs?: White_Last_Wasp_CryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<White_Last_Wasp_CryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_white_last_wasp_cry(inputs)
});